var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircularClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    fill: "none",
    viewBox: "0 0 14 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0B1C2A",
    fillOpacity: 0.5,
    d: "M7 .969A6.78 6.78 0 00.219 7.75 6.78 6.78 0 007 14.531a6.78 6.78 0 006.781-6.781A6.78 6.78 0 007 .969zm0 12.25A5.45 5.45 0 011.531 7.75 5.467 5.467 0 017 2.281c3.008 0 5.469 2.461 5.469 5.469A5.467 5.467 0 017 13.219zm2.762-7.164c.136-.11.136-.328 0-.465l-.602-.602c-.137-.136-.355-.136-.465 0L7 6.684 5.277 4.988c-.109-.136-.328-.136-.465 0l-.601.602c-.137.137-.137.355 0 .465L5.906 7.75 4.211 9.473c-.137.109-.137.328 0 .464l.601.602c.137.137.356.137.465 0L7 8.844l1.695 1.695c.11.137.328.137.465 0l.602-.601c.136-.137.136-.356 0-.465L8.066 7.75l1.696-1.695z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularClose);
export default __webpack_public_path__ + "static/media/circular-close.94fb61b677d415cffba5500722e81490.svg";
export { ForwardRef as ReactComponent };